const playWhenVisible = function(item, slider){
	const Obs = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if(!entry.isIntersecting){
				slider.pause();
			}
			else {
				slider.play();
			}
		});
	}, {
		root: null,
		rootMargin: '0px',
		threshold: 0.3
	});
	Obs.observe($(item).closest('.tns-outer')[0]);
};
const pagination = (info, item) => {
	const text = `${info.displayIndex}/${info.slideCount}`;
	let l = item.find('.tns-controls .count');
	if(!l.length){
		l = $('<div class="count"></div>').insertAfter(item.find('.tns-controls button:first'));
	}
	l.text(text);
};
$(document).ready(() => {

	const media = window.matchMedia("(max-width: 991px)");
	mobileSupport(media);
	media.addEventListener('change', mobileSupport);

	const setVh = () =>{
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}
	setVh();
	window.addEventListener('resize', setVh);

	const $body = $('body');

	$("form.validation").validationEngine({
		showPrompts: false,
		addFailureCssClassToField: "error",
		scroll: false,
		onFieldFailure: function (field) {
			if (field) {
				if (field.is(":radio")) {
					$(field).closest(".radio").addClass("error");
				}
			}
		},
		onFieldSuccess: function (field) {
			if (field) {
				if (field.is(":radio")) {
					$(field).closest(".radio").removeClass("error");
				}
			}
		},
	});
	$("form.validation [class*=validate]").on("change blur keyup", function () {
		$(this).validationEngine("validate");
	});

	$("body").on("click", "form.ajax button[type=submit]", function (e) {
		e.preventDefault();
		postFormAjax($(this).closest("form"));
		return false;
	});

	$("[data-mask]").each(function () {
		const type = $(this).data("mask");
		switch (type) {
			case "phone":
				$(this).inputmask({
					showMaskOnHover: false,
					mask: "+\\9\\94   * ### ## ##",
					/*oncomplete: function () {
						const p = $(this).parent();
						if (!p.find("i.success").length)
							$("<i/>").addClass("success").appendTo(p);
						p.addClass("success");
					},
					onincomplete: function () {
						$(this).parent().removeClass("success");
					},*/
					onBeforeMask:function(value){
						value = value.replace(new RegExp(/[^0-9]/,'gi'),'');
						if(value.length === 12 && value.substring(0,3)==='994')value = value.substring(3);
						return value;
					},
					definitions: {
						"#": {
							validator: "[0-9]",
							cardinality: 1,
							casing: "lower",
						},
						"*": {
							validator: "(10|50|51|55|60|70|77|99)",
							cardinality: 2,
							prevalidator: [{validator: "[15679]", cardinality: 1}],
						},
					},
				});
				break;
			case "numeric":
			case "integer":
				$(this).inputmask(type, {rightAlign: false});
				break;
			case "cur":
				$(this).inputmask({
					suffix: " " + $(this).data("currency"),
					groupSeparator: ",",
					alias: "numeric",
					placeholder: "0",
					autoGroup: !0,
					digits: 2,
					digitsOptional: !1,
					clearMaskOnLostFocus: !1,
					rightAlign: false,
				});
				break;
		}
	});


	$("[data-match-height]").each(function () {
		$(this).find($(this).attr("data-match-height")).matchHeight();
	});


	if ($(".home-partners .slider").length) {
		const PartnersSlider = tns({
			container: ".home-partners .slider",
			items: 1,
			gutter: 14,
			controlsText: ["", ""],
			controls:false,
			nav: false,
			loop: false,
			autoplay: true,
			"edgePadding": 70,
			autoplayButtonOutput:false,
			autoplayHoverPause:true,
			//slideBy:"page",
			responsive: {
				640: {
					items: 2,
					edgePadding:0,
					controls:true,
					gutter: 24,
				},
				992: {
					items: 3
				},
				1180: {
					items: 4
				}
			}
		});
		playWhenVisible($(".home-partners .slider")[0], PartnersSlider);
		/*PartnersSlider.events.on('indexChanged', (info)=>{
			console.log(info);
			const text = info.displayIndex / info.slideBy + '/' + info.slideCount / info.slideBy;
			let l = $('.home-partners .tns-controls .count');
			if(!l.length){
				l = $('<div class="count"></div>').insertAfter('.home-partners .tns-controls button:first');
			}
			l.text(text);
		});*/

	}
	if ($(".home-social .slider").length) {
		const SocialSlider = tns({
			container: ".home-social .slider",
			items: 1,
			controlsText: ["", ""],
			nav: false,
			loop: false,
			autoplay: true,
			autoplayButtonOutput:false,
			autoplayHoverPause:true,
			onInit:(info)=>{ pagination(info, $('.home-social')); }
		});
		playWhenVisible($(".home-social .slider")[0], SocialSlider);
		SocialSlider.events.on('indexChanged', (info)=>{
			pagination(info, $('.home-social'));
		});

	}

	//tabs
	$body.on('click','.tabs[data-target] > *:not(.active)',function(e){
		e.preventDefault();
		const tab_parent =  $(this).closest('.tabs'),
			target = tab_parent.attr('data-target');
		if(tab_parent.length > 0 && target){

			const tab = $(this),
				tabs = tab_parent.find('>*'),
				index = tabs.index(tab);

			$(target).each(function(){
				const content = $(this).find('>*')
				content.removeClass('active');
				content.eq(index).addClass('active');
			});

			tabs.removeClass('active');
			tab.addClass('active');
		}
	});

	$(window).scroll(function () {
		if ($(window).scrollTop() > 300) {
			$(".back-to-top").addClass("show");
		} else {
			$(".back-to-top").removeClass("show");
		}
	});
	$(".back-to-top").on("click", function (e) {
		e.preventDefault();
		$("html, body").animate({ scrollTop: 0 }, "200");
	});

	const closeNavi = () => {
		const el = $('#header .navi');
		el.removeClass('active');
		el.find('.ct').removeAttr('style');
		setTimeout(()=>el.removeClass('anim'),500);
		$body.removeClass('disable_scroll');
		$body.off('click', closeNavi);
	};
	$('#header .navi .trigger').click(function (e){
		e.preventDefault();
		const el = $(this).parent();
		if(el.hasClass('active'))closeNavi();
		else {
			el.addClass('anim');
			const hh = $('#header').outerHeight() - $(window).scrollTop() - 2;
			setTimeout(()=>{
				el.addClass('active');
				el.find('.ct').attr('style', `height:calc(100vh - ${hh}px)`);
				$body.one('click', closeNavi);
			},2);
			$body.addClass('disable_scroll');
		}
	});
	$('#header .navi .ct').click(function (e){
		e.stopPropagation();
	});

	$('.faq .items > li > label').click(function (e){
		e.preventDefault();
		const li = $(this).parent();
		const dh = li.find('>label').outerHeight();
		if(li.hasClass('active')){
			li.removeClass('active').height(dh + 17);
			setTimeout(()=>li.removeClass('anim'),500);
		}
		else {
			li.height(dh).addClass('anim');
			const h = li.find('.text').outerHeight() + dh;
			li.addClass('active').height(h);
		}
	});

	$('#header .navi .ls > li:has(ul) > a').click(function (e){
		e.preventDefault();
		const el = $(this).parent();
		if(el.hasClass('active')){
			el.removeClass('active');
			el.find('ul').removeAttr('style');
		}
		else {
			el.addClass('active');
			const h = el.find('ul a').length * 53;
			el.find('ul').attr('style', `height:${h}px`);
		}
	});
	const naviActive = $('#header .navi .ls > li.active');
	if(naviActive.length){
		naviActive.each(function(){
			const h = $(this).find('ul a').length * 53;
			$(this).find('ul').attr('style', `height:${h}px`);
		});
	}

	if ($(".news-page .images").length) {
		const mediaQuery = window.matchMedia("(max-width: 640px)");
		const NewsImagesSlider = tns({
			container: ".news-page .images .slider",
			gutter: 24,
			"autoWidth": !mediaQuery.matches,
			controlsText: ["", ""],
			nav: false,
			loop: false,
			autoplay: true,
			autoplayButtonOutput:false,
			autoplayHoverPause:true,
		});
		playWhenVisible($(".news-page .images .slider")[0], NewsImagesSlider);
	}


	const searchPopup = $("#search-popup");
	const closeSearchPopup = function(){
		searchPopup.removeClass("active");
		$("body").removeClass("disable_scroll");
		searchPopup.removeAttr('style');
		setTimeout(()=>searchPopup.removeClass('anim'),500);
		$body.off('click', closeSearchPopup);
		$('header#header .lang > a').off('click', closeSearchPopup);
	};
	//search
	$("#header button.search").on("click", function (e) {
		if(searchPopup.hasClass('active'))return;
		if($('.search-page').length){
			$('.search-page form input').focus();
			return;
		}
		$("body").addClass("disable_scroll");
		searchPopup.addClass("anim");
		const hh = $('#header').outerHeight() - $(window).scrollTop() - 2;
		setTimeout(()=>{
			searchPopup.addClass('active');
			searchPopup.attr('style', `height:calc(100vh - ${hh}px)`);
			$body.one('click', closeSearchPopup);
			$('header#header .lang > a').one('click', closeSearchPopup);
		},2);
	});
	const searchForm = $("#search-popup form");
	searchForm.click(function(e){
		e.stopPropagation();
	});
	searchPopup.click(function(e){
		e.stopPropagation();
	});
	$("#search-popup .back").on("click", closeSearchPopup);
});

$.isMobile = false;
const mobileSupport = (media) => {
	if (media.matches) {
		$.isMobile = true;

		$(document).trigger("mobileOn");
	} else {
		$.isMobile = false;

		$(document).trigger("mobileOff");
	}
};
function postFormAjax(form) {
	if (form.validationEngine("validate") && form.attr("request") != 1) {
		let url = form.attr("action");

		const disabled = [];

		form.find(":disabled").each(function () {
			disabled.push(this);
			$(this).prop("disabled", false).removeProp("disabled");
		});
		let data = form.serialize();

		$.each(disabled, function () {
			$(this).prop("disabled", true);
		});

		$.ajax({
			url: url,
			type: "POST",
			dataType: "json",
			cache: false,
			data: data,
			beforeSend: function () {
				form.attr("request", 1);
				if (
					form.css("position") != "absolute" &&
					form.css("position") != "relative"
				)
					form.css("position", "relative");
				$(
					'<div class="loading"><div class="lds-ripple"><div></div><div></div></div></div>'
				).appendTo(form);
			},
			success: function (data) {
				form.attr("request", 0);
				if (data.code == 200) {
					form.addClass("success");
					form.find('button[type="submit"]').prop("disabled", true);
				} else if (typeof data.message != "undefined") {
					alertify.error(data.message);
				}
			},
			error: function (x, e) {
				form.attr("request", 0);
				var e_msg = "";
				if (x.status == 0)
					e_msg = "You are offline!!<br> Please Check Your Network.";
				else if (x.status == 404) e_msg = "Requested URL not found.";
				else if (x.status == 500)
					e_msg = "Internel Server Error." + x.responseText;
				else if (e == "parsererror")
					e_msg = "Error.<br>Parsing JSON Request failed.";
				else if (e == "timeout") e_msg = "Request Time out.";
				else if (e == "error") e_msg = "Request error.";
				else if (e == "abort") e_msg = "Request abort.";
				else e_msg = "Unknow Error.<br>" + x.responseText;
			},
			complete: function () {
				$(".loading").remove();
			},
		});
	}
}

